<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" depressed>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>
    <v-card
      width="400"
    >
      <p class="text-center pa-3">
        {{ $t("message.app_menu.desc") }}
      </p>
      <v-card
        class="d-flex justify-space-between"
        flat
      >
        <v-container>
          <v-row>
            <v-col
              v-for="(item, index) in items"
              :key="item.title"
            >
              <template v-if="!item.title.startsWith('spacer')">
                <v-card
                  class="pa-3 d-flex align-center justify-center"
                  tile
                  @click="popup(item.url, item.target)"
                  height="100%"
                >
                  <v-card
                    width="100%"
                    flat
                  >
                    <v-layout justify-center>
                      <v-img
                        width="64"
                        :src="require('@/assets/' + item.icon)"
                        class="text-center"
                      />
                    </v-layout>
                    <v-card-subtitle
                      class="text-center pl-0 pr-0"
                    >
                      {{ item.title }}
                    </v-card-subtitle>
                  </v-card>
                </v-card>
              </template>
              <template v-else>
                <v-spacer />
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'app_menu',
  data: function(){
    return {
      module_id: "52",
    }
  },
  methods: {
    popup: function(url, target){
      window.open(url, target);
    }
  },
  computed: {
    items: function(){
      var items = [
        {
          target: "t4oo",
          title: this.$i18n.t("message.app_menu.t4oo"),
          icon: "app_t4oo.png",
          url: "https://www.rozetta.jp/suite/t4oo/"
        }
      ];
      if(this.$store.getters.domain === "t-3mt"){
        items.push({
          target: "thereading",
          title: this.$i18n.t("message.app_menu.thereading"),
          icon: "app_thereading.png",
          url: "https://www.rozetta.jp/suite/thereading/"
        });
      }else{
        items.push({
          target: "t3mt",
          title: this.$i18n.t("message.app_menu.t3mt"),
          icon: "app_t3mt.png",
          url: "https://www.rozetta.jp/suite/t3mt/"
        });
      }
      items.push(
        {
          target: "onyaku",
          title: this.$i18n.t("message.app_menu.onyaku"),
          icon: "app_onyaku.png",
          url: "https://www.rozetta.jp/suite/onyaku/"
        },
        {
          target: "api",
          title: this.$i18n.t("message.app_menu.api"),
          icon: "app_api.png",
          url: "https://www.rozetta.jp/suite/api/"
        },
        {
          target: "phrase",
          title: this.$i18n.t("message.app_menu.phrase"),
          icon: "app_phrase.png",
          url: "https://www.rozetta.jp/suite/phrase/"
        },
        {
          target: "summarizer",
          title: this.$i18n.t("message.app_menu.summarizer"),
          icon: "app_summarizer.png",
          url: "https://www.rozetta.jp/metarealai/summarizer/"
        },
        {
          target: "stt",
          title: this.$i18n.t("message.app_menu.stt"),
          icon: "app_speech_to_text.png",
          url: "https://www.rozetta.jp/metarealai/stt/"
        },
        {
          target: "presengen",
          title: this.$i18n.t("message.app_menu.presengen"),
          icon: "app_presentation_generator.png",
          url: "https://www.rozetta.jp/metarealai/presengen/"
        },
        {
          target: "proofreader",
          title: this.$i18n.t("message.app_menu.proofreader"),
          icon: "app_proofreader.png",
          url: "https://www.rozetta.jp/metarealai/proofreader/"
        },
      );
      return items;
    }
  }
}
</script>
<style scoped>
p {
  margin-bottom: 0
}
</style>
